









































































































































import masterdata, {
    KnownValuesResponseModelULC,
    CompanyListItem,
    MDServerResponse,
    NewSupplierFormAndRequest,
    NewSupplierListContent,
    ListElement,
} from '@/services/masterdata';

import ShowMDResponse from '@/components/masterData/components/ShowMDResponse.vue';
import step1BasicCompanyInfo from '@/components/masterData/components/step1BasicCompanyInfo.vue';
import IbanAndPDFinput from '@/components/masterData/components/IbanAndPDFinput.vue';
import PaymentandTerms from '@/components/masterData/components/PaymentandTerms.vue';
import SupplierInfo from '@/components/masterData/components/SupplierInfo.vue';

export default {
    components: {
        'md-response': ShowMDResponse,
        'md-step1': step1BasicCompanyInfo,
        'md-iban': IbanAndPDFinput,
        'md-payment': PaymentandTerms,
        'md-supinfo': SupplierInfo,
    },
    data(this: any): any {
        return {
            rules: {
                NotificationEmail: [
                    { required: true, message: this.$t('masterDataFromRules.Required'), trigger: ['blur', 'change'] },
                    { type: 'email', message: this.$t('masterDataFromRules.Email'), trigger: ['blur', 'change'] },
                ],
                CmrReminder: [
                    { required: true, message: this.$t('masterDataFromRules.Required'), trigger: ['blur', 'change'] },
                    { type: 'email', message: this.$t('masterDataFromRules.Email'), trigger: ['blur', 'change'] },
                ],
            },
            companycode: 0,
            societa: 0,
            societaUser: 0,
            resivedData: false,
            lists: {} as NewSupplierListContent,
            newSupplierForm: {} as NewSupplierFormAndRequest,
            step: 0,
            nazione: '',
            form: {},
            errors: [],
            response: null,
            validate: false,
            pdfFile: null,
            formstyle: {
                labelwidth: '175px',
                labelposition: 'right',
            },
            componentValid: {
                iban: false,
                payment: false,
                supInfo: false,
            },
        };
    },
    computed: {
        computeTest(this: any) {
            return this.componentValid.iban && this.componentValid.payment && this.componentValid.supInfo;
        },
    },
    watch: {
        computeTest(this: any, newVal: any, oldVal: any) {
            if (newVal) {
                this.nextStep('step2');
            }
        },
    },
    methods: {
        async getCompanies(this: any) {
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                background: 'rgba(0, 0, 0, 0.7)',
            });
            try {
                this.companyListItemList = await masterdata.getULSSupplierList(this.companycode, this.societa, this.societaUser);
            } catch (error) {
                masterdata.errorMessageAlert(this, error, loading, 'masterData.GetFailed', 'masterData.CompanyGetFailed');
                return;
            }
            this.resivedData = true;
            loading.close();
            if (this.companyListItemList.length === 1) {
                this.getData(-1, this.companyListItemList[0]);
            }
        },
        async getData(this: any, index: any, row: CompanyListItem) {
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                background: 'rgba(0, 0, 0, 0.7)',
            });
            let item: KnownValuesResponseModelULC | undefined;
            let lists: NewSupplierListContent | undefined;
            try {
                item = await masterdata.getULSKnownValues(this.companycode, this.societa, this.societaUser, row.ClienteFornitoreCodice, row.SocietaCollegamento);
            } catch (error) {
                masterdata.errorMessageAlert(this, error, loading, 'masterData.GetFailed', 'masterData.CompanyGetFailed', false);
                return;
            }
            try {
                lists = await masterdata.getNSListContent(this.companycode, this.societa, this.societaUser);
            } catch (error) {
                masterdata.errorMessageAlert(this, error, loading, 'masterData.GetFailed', 'masterData.ListGetFailed', false);
                return;
            }
            loading.close();
            if (item !== null && lists !== null) {
                this.newSupplierForm = item;
                this.newSupplierForm.SocietaCollegamento = row.SocietaCollegamento;
                this.newSupplierForm.ClienteFornitoreCodice = row.ClienteFornitoreCodice;
                this.Outdated = row.Outdated;
                this.lists = lists;
                this.newSupplierForm.CreditLimit = this.newSupplierForm.CreditLimit;
                this.step += 1;
                this.nazione = this.newSupplierForm.Lingua;
                if (this.lists.Lingua.filter((i: ListElement) => i.Codice === this.newSupplierForm.Lingua).length === 0) {
                    this.newSupplierForm.Lingua = 'GB';
                }

                if (!this.Outdated) {
                    this.onSubmit();
                }
            } else {
                this.$alert(this.$t('masterData.NewCustomerFailedMessage'), this.$t('masterData.NewCustomerFailedTitel'), {
                    type: 'error',
                    confirmButtonText: 'OK',
                    center: true,
                });
            }
        },
        async nextStepStep2(this: any) {
            this.componentValid.payment = false;
            this.componentValid.iban = false;
            this.componentValid.supInfo = false;
            this.validate = !this.validate;
            this.$refs.step2.validate();
        },
        async nextStep(this: any, formName: string) {
            let valid = true;
            if (formName) {
                this.$refs[formName].validate((val: any) => {
                    valid = val;
                });
            }
            if (valid) {
                this.step += 1;
            }
            if (this.step === 3) {
                this.onSubmit();
            }
        },
        backStep(this: any, formName: string) {
            this.$refs[formName].clearValidate();
            this.step -= 1;
        },
        async onSubmit(this: any) {
            this.error = [];
            let fileByteArray: any[] | null = null;
            let filename: string | null = null;
            if (this.pdfFile != null) {
                fileByteArray = [];
                filename = this.pdfFile.name;
                try {
                    const array = new Uint8Array(await masterdata.readUploadedFileAsArrayBuffer(this.pdfFile.raw));
                    for (let i = 0; i < array.length; i += 1) {
                        fileByteArray.push(array[i]);
                    }
                } catch (e) {
                    console.warn(e.message);
                    return;
                }
                this.newSupplierForm.pdfFile = fileByteArray;
                this.newSupplierForm.pdfFileName = filename;
            }
            const loading = this.$loading({ lock: true, text: 'Loading', background: 'rgba(0, 0, 0, 0.7)' });
            let response: MDServerResponse;
            try {
                response = await masterdata.sendDataNS(this.companycode, this.societa, this.societaUser, this.newSupplierForm);
            } catch (error) {
                if (error.response != null && Array.isArray(error.response.data)) {
                    this.errors = error.response.data;
                    loading.close();
                } else {
                    masterdata.errorMessageAlert(this, error, loading, 'masterData.NewCustomerFailedTitel', 'masterData.NewCustomerFailedMessage', false);
                    this.step -= 1;
                }
                return;
            }
            loading.close();
            this.response = response;
        },
    },
    mounted(this: any) {
        this.companycode = this.$route.query.companycode;
        this.societa = this.$route.query.societa;
        this.societaUser = this.$route.query.societaUser;
        this.getCompanies();
    },
};
